import { ILayerProps } from "./OverallDowntimeSummaryPieChartCenteredMetricInterfaces";
import { truncateLongText } from "../../utilities/utilities";

export const OverallDowntimeSummaryPieChartCenteredMetric =
    (data: { name: string; value: number }) =>
    ({ centerX, centerY }: ILayerProps) => {
        return (
            <>
                <text
                    x={centerX}
                    y={centerY}
                    textAnchor="middle"
                    dominantBaseline="auto"
                    style={{
                        fontSize: 30,
                        fontWeight: 300,
                        pointerEvents: "none",
                    }}
                >
                    {data.value !== 0 ? `${data.value}%` : ""}
                </text>
                <text
                    x={centerX}
                    y={centerY}
                    textAnchor="middle"
                    dominantBaseline="hanging"
                    style={{
                        fontSize: 14,
                        fontWeight: 400,
                        pointerEvents: "none",
                    }}
                >
                    {data.name !== "" ? truncateLongText(data.name, 18) : ""}
                </text>
            </>
        );
    };
